import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "tracked-built-ins"

export default class HelpMenuButton extends Component {
  // @ts-ignore Not sure why it's not picking this up.
  @service("undo") undoService

  @tracked canShowMenu = false

  @action
  undoIt() {
    this.undoService.pop()
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    HelpMenuButton: typeof HelpMenuButton
  }
}
